import { render, staticRenderFns } from "./UbicateTree.vue?vue&type=template&id=da3550e6&"
import script from "./UbicateTree.vue?vue&type=script&lang=js&"
export * from "./UbicateTree.vue?vue&type=script&lang=js&"
import style0 from "./UbicateTree.vue?vue&type=style&index=0&id=da3550e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports